import { Amplify } from 'aws-amplify';
import awsExports from '../aws-exports';

/**
 * CloudFormation-managed APIs that aren't in aws-exports.js
 * These are configured separately to avoid manual aws-exports.js maintenance
 */
export const CLOUDFORMATION_APIS = [
  {
    name: 'slughornUserEventsAggregation',
    endpoint: 'https://hyileqtaxj.execute-api.eu-west-2.amazonaws.com/staging',
    region: 'eu-west-2'
  }
];

/**
 * Configure CloudFormation-managed APIs with Amplify
 * Call this after Amplify.configure() in your app initialization
 */
export function configureCloudFormationAPIs() {
  // Build combined aws_cloud_logic_custom array
  const existingApis = awsExports.aws_cloud_logic_custom || [];
  const combinedApis = [...existingApis, ...CLOUDFORMATION_APIS];

  // Reconfigure Amplify with merged APIs
  Amplify.configure({
    ...awsExports,
    aws_cloud_logic_custom: combinedApis
  });

}
